/*
Copyright 2021-2024 New Vector Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
*/

import { useTranslation } from "react-i18next";
import { type FC } from "react";
import React from 'react';

import { useClientState } from "../ClientContext";
import { ErrorPage, LoadingPage } from "../FullScreenView";
import { UnauthenticatedView } from "./UnauthenticatedView";
import { RegisteredView } from "./RegisteredView";
import { usePageTitle } from "../usePageTitle";
import { widget } from "../widget.ts";

export const HomePage: FC = () => {
  const { t } = useTranslation();
  usePageTitle(t("common.home"));

  const clientState = useClientState();

  // --- НАШ КАСТОМНЫЙ БЛОК ДЛЯ ДОМЕНА JOIN ---
  const guestDomain = import.meta.env.VITE_GUEST_URL || "join.sharecoop.icloud.ec";
  if (window.location.origin === guestDomain) {
    return (
      <div style={{
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        height: "100vh", 
        backgroundColor: "#15191e",
        color: "#ffffff",
        fontFamily: "sans-serif",
        textAlign: "center",
        padding: "20px"
      }}>
        <h1 style={{ fontSize: "2rem", marginBottom: "16px" }}>
          ShareCoop Calls
        </h1>
        <p style={{ fontSize: "1.2rem", color: "#a1a1a1", maxWidth: "400px" }}>
          Для подключения к видеоконференции, пожалуйста, перейдите по ссылке-приглашению.
        </p>
      </div>
    );
  }
  // ------------------------------------------

  if (!clientState) {
    return <LoadingPage />;
  } else if (clientState.state === "error") {
    return <ErrorPage widget={widget} error={clientState.error} />;
  } else {
    return (
      <>
        {/* НАДЕЖНАЯ ПЛАВАЮЩАЯ КНОПКА (Всегда внизу справа) */}


        {clientState.authenticated ? (
          <RegisteredView client={clientState.authenticated.client} />
        ) : (
          <UnauthenticatedView />
        )}
      </>
    );
  }
};